import { CloseIcon } from '@fourthwall/icons'
import React from 'react'
import { Checkboard } from '../../partials/Checkboard'
import { Icon } from '../Icon'
import type { ImageProps, Props, VideoProps } from './types'
import * as S from './UploadedAsset.styled'

export const UploadedAsset = ({
  id,
  src,
  withCheckboard = false,
  disabled,
  appearance,
  onClick,
  onRemove,
  children,
}: Props) => {
  const handleRemove = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    onRemove(id)
  }

  const handleClick = () => {
    if (onClick) {
      onClick(src)
    }
  }

  return (
    <S.Container
      key={id}
      $disabled={disabled}
      $appearance={appearance}
      onClick={handleClick}
      data-testid="UploadedAsset.Container"
    >
      {withCheckboard && <Checkboard size={16} white="#646560" grey="#40413D" />}
      {children}
      <S.RemoveButton aria-label="Remove" onClick={handleRemove}>
        <Icon component={CloseIcon} height={12} />
      </S.RemoveButton>
    </S.Container>
  )
}

UploadedAsset.Video = function ({ src, controls = true }: VideoProps) {
  return <S.Video src={src} controls={controls} />
}
UploadedAsset.Image = function ({ src, alt = '' }: ImageProps) {
  return <S.Image src={src} alt={alt} />
}
